export enum FavouriteMessage {
  SuccessAdd = `"{name}" added to favorites.`,
  SuccessRemove = `"{name}" removed from favorites.`,
}
